import { createContext, useContext, type ReactNode } from "react";

import { useDialogSteps } from "ui/dialog";
import { TOTAL_ADD_CREATIVES_WITH_WRITER_STEPS } from "components/modals/add-creatives-with-writer-modal/add-creatives-with-writer-modal.constants";

import type { AddCreativesWithWriterContextType } from "components/modals/add-creatives-with-writer-modal/add-creatives-with-writer-modal.types";

const AddCreativesWithWriterContext = createContext<AddCreativesWithWriterContextType | undefined>(
  undefined,
);

interface AddCreativesWithWriterContextProviderProps {
  children: ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  folderId?: string;
}

export const AddCreativesWithWriterContextProvider = ({
  children,
  isOpen,
  setIsOpen,
  folderId,
}: AddCreativesWithWriterContextProviderProps) => {
  const steps = useDialogSteps({ total: TOTAL_ADD_CREATIVES_WITH_WRITER_STEPS });

  const value = { ...steps, isOpen, setIsOpen, folderId };

  return (
    <AddCreativesWithWriterContext.Provider value={value}>
      {children}
    </AddCreativesWithWriterContext.Provider>
  );
};

export const useAddCreativesWithWriterContext = () => {
  const context = useContext(AddCreativesWithWriterContext);

  if (context === undefined) {
    throw new Error(
      "useAddCreativesWithWriterContext must be used within an AddCreativesWithWriterContextProvider",
    );
  }

  return context;
};
